var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.358 12.0453C10.1483 13.0935 8.60072 13.6696 7.00004 13.6673C3.31804 13.6673 0.333374 10.6827 0.333374 7.00065C0.333374 3.31865 3.31804 0.333984 7.00004 0.333984C10.682 0.333984 13.6667 3.31865 13.6667 7.00065C13.6667 8.42465 13.22 9.74465 12.46 10.8273L10.3334 7.00065H12.3334C12.3333 5.77146 11.9086 4.58003 11.1312 3.62791C10.3537 2.6758 9.27128 2.02145 8.06693 1.77556C6.86258 1.52967 5.61026 1.70733 4.52183 2.2785C3.43339 2.84966 2.57566 3.77926 2.09372 4.91004C1.61179 6.04082 1.53524 7.30336 1.87703 8.48408C2.21883 9.6648 2.95797 10.6912 3.96943 11.3897C4.98089 12.0882 6.20257 12.4158 7.4278 12.3172C8.65304 12.2187 9.80661 11.6999 10.6934 10.8487L11.358 12.0453Z",
    fill: "#6E7DAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/Reload.9c61021cadc9178aaab6d26a131b505d.svg";
export { ForwardRef as ReactComponent };